import {all, call, fork, put, takeEvery} from 'bukku/shared/SagaService';
import {message} from 'antd';
import actions from './actions';
import {get} from 'bukku/shared/ApiService';

// Read transactions
export function* readTransactionsRequest() {
    yield takeEvery(actions.SEARCH_READ_TRANSACTIONS_REQUEST, function* ({ request }, context) {
        try {
            const response = yield call(get, '/search/transactions', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.SEARCH_READ_TRANSACTIONS_SUCCESS,
                transactions: data.transactions,
            });
        }
        catch (error) {
            yield put({
                type: actions.SEARCH_READ_TRANSACTIONS_ERROR,
                error,
            });
        }
    });
}
export function* readTransactionsSuccess() {
    yield takeEvery(actions.SEARCH_READ_TRANSACTIONS_SUCCESS, () => {});
}
export function* readTransactionsError() {
    yield takeEvery(actions.SEARCH_READ_TRANSACTIONS_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

export default function* rootSaga() {
    yield all([
        fork(readTransactionsRequest),
        fork(readTransactionsSuccess),
        fork(readTransactionsError),
    ]);
}
